import React from 'react';

export default function LoadingSpinner({ message }) {
  return (
    <div className="loading-container">
      <div className="spinner" />
      {message && <span>{message}</span>}
    </div>
  );
}
